import React from 'react'
import { SelectChangeEvent, TextField } from '@mui/material'

import InfoButton from '../InfoButton/InfoButton'
import * as Styled from './styles'

interface Props {
  id: string
  type?: 'default' | 'filter'
  value: string | number
  onChange: (e: SelectChangeEvent<unknown>) => void
  options: Array<{
    key?: string | number
    value?: string | number
    disabled?: boolean
  }>
  formatterForOption?: (value: string | number) => string
  label: string
  dangerouslySetInfo?: string
}

const Select: React.FC<Props> = ({
  id,
  type = 'default',
  value,
  onChange,
  options,
  formatterForOption = (option: any): any => option,
  label,
  dangerouslySetInfo = '',
}) => {
  return (
    <Styled.Select type={type}>
      <div>
        <label htmlFor={id}>{label}</label>
        {dangerouslySetInfo && <InfoButton dangerouslySetInfo={dangerouslySetInfo} />}
      </div>
      <TextField
        id={id}
        select
        SelectProps={{
          native: true,
          value,
          onChange,
        }}
      >
        {options.map(({ key, value, disabled }) => (
          <option key={key} value={value} disabled={disabled}>
            {value !== undefined ? formatterForOption(value) : 'undefined'}
          </option>
        ))}
      </TextField>
    </Styled.Select>
  )
}

export default Select
